export default __webpack_public_path__ + "static/media/panthertest0.17.22e09e42.png";